import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { TermsOverlay } from './termsOverlay.component';
import { selectIsOverlayStandalone, selectIsTermsVisible, OverlayActions } from '../../../modules/overlay';
import { LegalActions, selectTermsAndConditionsContent } from '../../../modules/legal';

const mapStateToProps = createStructuredSelector({
  content: selectTermsAndConditionsContent,
  isVisible: selectIsTermsVisible,
  isStandalone: selectIsOverlayStandalone,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showOverlay: OverlayActions.showTerms,
      hideOverlay: OverlayActions.hideOverlay,
      fetchTerms: LegalActions.fetchTermsAndConditions,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(TermsOverlay);
